// extracted by mini-css-extract-plugin
export var menu__item = "NavigationMobileMenuItem-module--menu__item--WPnIu";
export var menu__anchor = "NavigationMobileMenuItem-module--menu__anchor--17rwm";
export var menu__anchorActive = "NavigationMobileMenuItem-module--menu__anchor--active--323zi";